import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import { AppState } from '../reducers';
import {
  updateProductCount,
  updateCategoryMap,
} from './copy-stream-categories.actions';
import {
  getStoryInitialSourceCategories,
  getStoryEditActiveAppId,
  getStoryEditActiveAppConfig,
} from '../StoryEdit/story-edit.reducer';
import * as R from 'ramda';
import { SourceCategory } from '../Entities/Stories/stories.reducer';
import { getCategoryById } from '../Entities/Categories/categories.reducer';

export interface ProductCount {
  [categoryId: number]: number;
}

export interface CategoryMap {
  [appId: number]: {
    [categoryId: number]: number;
  };
}

export interface CopyStreamCategories {
  productCount: ProductCount;
  categoryMap: CategoryMap;
}

const initialState = Immutable.from<CopyStreamCategories>({
  productCount: [],
  categoryMap: [],
});

export type CopyStreamCategoriesState = CopyStreamCategories &
  Immutable.ImmutableObject<CopyStreamCategories>;

export default function reduce(
  state: CopyStreamCategoriesState = initialState,
  action: Action
) {
  if (isType(action, updateProductCount)) {
    const {
      payload: { categoryId, productCount },
    } = action;

    return state.merge(
      {
        productCount: {
          [categoryId]: productCount,
        },
      },
      { deep: true }
    );
  }

  if (isType(action, updateCategoryMap)) {
    const {
      payload: { categoryMap },
    } = action;

    return state.merge(
      {
        categoryMap,
      },
      { deep: true }
    );
  }

  return state;
}

export function getProductCount(state: AppState) {
  const {
    copyStreamCategories: { productCount },
  } = state;

  return productCount;
}

export function getCategoryMap(state: AppState) {
  const {
    copyStreamCategories: { categoryMap },
  } = state;

  return categoryMap;
}

export function getMappedCategories(state: AppState): SourceCategory[] {
  const categoryMap = getCategoryMap(state);

  if (!categoryMap) {
    return [];
  }

  return getVirtualSourceCategories(state, categoryMap);
}

export function getCopiedCategories(state: AppState): SourceCategory[] {
  const activeAppConfig = getStoryEditActiveAppConfig(state);

  if (!activeAppConfig || !activeAppConfig.sourceCategories) {
    return [];
  }

  return activeAppConfig.sourceCategories.map((sourceCat: SourceCategory) => {
    return sourceCat;
  });
}

export function getVirtualSourceCategories(
  state: AppState,
  categoryMap: CategoryMap
): SourceCategory[] {
  const initialSourceCategories = getStoryInitialSourceCategories(state);
  const currentAppId = getStoryEditActiveAppId(state);
  if (!currentAppId || initialSourceCategories.length === 0) {
    return [];
  }

  const currentCategoryMap = categoryMap[currentAppId];

  return R.map(
    (sourceCategory: SourceCategory) => {
      const categoryId = currentCategoryMap[sourceCategory.categoryId];

      return {
        ...sourceCategory,
        categoryId,
        categoryKey: sourceCategory.categoryId,
        appConfigId: currentAppId,
        category: getCategoryById(state, currentAppId, categoryId),
      };
    },
    initialSourceCategories.filter((sourceCat: SourceCategory) => {
      return R.contains('' + sourceCat.categoryId, R.keys(currentCategoryMap));
    })
  );
}



// WEBPACK FOOTER //
// ./src/store/CopyStreamCategories/copy-stream-categories.reducer.ts